import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  LicensedComponentDto,
  LicensedProductDto,
} from 'src/app/models/license.model';

@Component({
  selector: 'app-license-product-card',
  templateUrl: './license-product-card.component.html',
  styleUrls: ['./license-product-card.component.scss'],
  standalone: false,
})
export class LicenseProductCardComponent {
  @Input() product: LicensedProductDto | null = null;
  @Input() showActions = false;
  @Output() editProduct = new EventEmitter<string>();
  @Output() deleteProduct = new EventEmitter<string>();

  onEdit(): void {
    const productId = this.product?.id;
    if (!productId) {
      return;
    }
    this.editProduct.emit(productId);
  }

  onDelete(): void {
    const productId = this.product?.id;
    if (!productId) {
      return;
    }
    this.deleteProduct.emit(productId);
  }

  getComponentName(component?: LicensedComponentDto | null): string {
    return component?.componentName?.trim() || 'Unknown Component';
  }
}
